import actions from './actions';

import { DataService } from '../../config/data/dataService';
const {  
    getASMSalesDashboardBegin, getASMSalesDashboardSuccess, getASMSalesDashboardErr,
    getStoreRankingDataBegin, getStoreRankingDataSuccess, getStoreRankingDataErr, 
} = actions;

export const getASMSalesDashboard = () => {
    return async (dispatch) => {
        try {
            dispatch(getASMSalesDashboardBegin());
            const response = await DataService.get('/getASMSalesDashboard');
            if (response.status === 200 && response.data.status === true) {
                dispatch(getASMSalesDashboardSuccess(response.data.data));
            } else {
                dispatch(getASMSalesDashboardErr(response.data));
            }
        } catch (err) {
            dispatch(getASMSalesDashboardErr(err));
        }
    };
}

// Ranking Data
export const getStoreRankingData = (data) => {
    return async (dispatch) => {
        try {
            dispatch(getStoreRankingDataBegin());
            const response = await DataService.post('/getStoreRankingData', data);
            if (response.status === 200 && response.data.status === true) {
                dispatch(getStoreRankingDataSuccess(response.data.data));
            } else {
                dispatch(getStoreRankingDataErr(response.data));
            }
        } catch (err) {
            dispatch(getStoreRankingDataErr(err));
        }
    };
}

